import { ADDTOCART, DELETECART, MINUSQTY, PLUSQTY } from "./actionTypes";

export const addtocart = (id)=>{
    return {
        type: ADDTOCART,
        payload: id,
    }
}

export const minusqty = (id)=>{
    return{
        type: MINUSQTY,
        payload: id,
    }
}
export const plusqty = (id)=>{
    return{
        type: PLUSQTY,
        payload: id,
    }
}
export const deletecart = (id)=>{
    return{
        type: DELETECART,
        payload: id,
    }
}
